import { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { DeleteOutline, BugReportOutlined } from '@mui/icons-material';
import { subscribe } from '../../services/utils/pubsub';
import { ComponentEvents } from '../../services/wss/events/ComponentEvents';
import { EngineNames } from '../../services/wss/events/EngineNames';
import logEngine from '../../services/engines/log/LogEngine'; // CHANGED — moved to log subfolder
import logPublisher from '../../services/engines/log/LogPublisher';
import logService from '../../services/wss/logService3';

/**
 * LogTab — admin only.
 * Shows buffered FE error log from LogEngine.
 * Read-only — no mutations, only clear.
 */
export default function LogTab() {
    const [entries, setEntries] = useState(() => logEngine.getEntries());

    useEffect(() => {
        return subscribe(ComponentEvents.channel, (e) => {
            if (e.name !== EngineNames.LogEngine) return;
            if (e.target !== 'logsChanged') return;
            setEntries([...e.data.entries]);
        });
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexShrink: 0 }}>
                <Typography variant="body2" sx={{ color: 'var(--j-muted)' }}>
                    FE Error Log — {entries.length} entries
                </Typography>
                <Tooltip title="Test error — add to local cache">
                    <IconButton
                        size="small"
                        onClick={() => logService.logError('LogTab.test: test error')}
                        sx={{ color: '#294766', '&:hover': { color: '#66b2ff' } }}
                    >
                        <BugReportOutlined fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Test POST — flush to Gateway">
                    <IconButton
                        size="small"
                        onClick={async () => {
                            // Build a single test entry matching the DTO shape
                            const entry = {
                                app: 'Jerny',
                                // uid: AppContext.getUid?.() ?? 'unknown',
                                source: 'LogTab',
                                method: 'testPost',
                                message: 'Manual test POST from LogTab',
                                ems: Date.now(),
                                count: 1,
                                lastSeen: Date.now(),
                            };
                            const ok = await logPublisher.publish([entry]);
                            // eslint-disable-next-line no-console
                            console.log('[LogTab] testPost result:', ok);
                        }}
                        sx={{ color: '#294766', '&:hover': { color: '#66ff99' } }}
                    >
                        <BugReportOutlined fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Clear log">
                    <IconButton size="small" onClick={() => logEngine.clear()} sx={{ color: '#294766', '&:hover': { color: '#ff6b6b' } }}>
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{ flex: 1, overflowY: 'auto', fontFamily: 'monospace', fontSize: 12 }}>
                {entries.length === 0 && (
                    <Typography variant="caption" sx={{ color: 'var(--j-muted)' }}>
                        No errors.
                    </Typography>
                )}
                {entries.map((e, i) => (
                    <Box key={i} sx={{ py: 0.5, borderBottom: '0.5px solid #1e3a52', color: '#ff6b6b' }}>
                        {e.message}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
